import { Box, LinearProgress } from "@mui/material";
import { ReactComponent as ArrowDown } from "assets/CollapseArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/CollapseArrowUp.svg";
import JoineUserMobile from "assets/joineUserMobile.svg";
import { ReactComponent as JoinUser } from "assets/joinUser.svg";
import { ReactComponent as NewPlan } from "assets/newPlan.svg";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import ToolTip from "components/common/Tooltip";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getDateColor, getMoreValues, getNamesFromHtlId, getTableColor, getUserHltId } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { joiningToPlanAsync } from "../PlanDetail.slice";
import "./AddToMyPlans.scss";

interface Props {
  data?: any;
  openDialog: boolean;
  handleClose: () => void;
  startNewPlan: () => void;
}

const AddToMyPlans = (props: Props) => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { openDialog, handleClose, startNewPlan } = props;

  const [arrowDown, setArrowDown] = useState(true);

  const memberDetails = useAppSelector((state) => state.planDetails.memberDetails);
  const data = useAppSelector((state) => state.planDetails.implementedPlansToJoin);

  const handleCollapse = () => {
    setArrowDown(!arrowDown);
  };

  const joinPlan = async (el: any) => {
    const params = { id: el.planId, isHotelUserJoiningToPlan: true };
    const userHtlid = getUserHltId();
    const htlIds = [...el?.planMembers];
    htlIds.push(userHtlid);
    const payload = { payload: { members: htlIds }, ...params };
    await dispatch(joiningToPlanAsync(payload));
    navigate(`/myplandetails/${el.planId}`);
  };

  const getPlanListUi = () => {
    const showData = arrowDown ? data.slice(0, 2) : data;
    return showData?.map((el: any, index: number) => {
      const progressVal = el?.completedCardsCount / el?.cardsCount;
      return (
        <div>
          <div className="add-to-myplan-list-box">
            <div className="div-gradient">
              {data?.length > 2 && arrowDown && index === 1 && <div className="gradient-overlay"></div>}
              <div className="content" style={{ display: "flex" }}>
                <div className="list-data-box">
                  <div className="list-data">
                    {" "}
                    <Typography variant={"label"} showBold color={tokens.Text.General.PrimaryBody}>
                      Owner(s)
                    </Typography>
                    <Typography variant={"body2"} color={tokens.Text.General.PrimaryHeadline}>
                      <ToolTip
                        title={
                          el?.planOwners?.length > 1 ? getNamesFromHtlId(el?.planOwners, memberDetails).join(", ") : ""
                        }
                      >
                        <Box component={"span"}> {getMoreValues(getNamesFromHtlId(el?.planOwners, memberDetails))}</Box>
                      </ToolTip>
                    </Typography>
                  </div>
                  <div className="list-data">
                    {" "}
                    <Typography variant={"label"} showBold color={tokens.Text.General.PrimaryBody}>
                      Start Date
                    </Typography>
                    <Typography variant={"body2"} color={tokens.Text.General.PrimaryHeadline}>
                      {getUIFormatDate(el.createdDate)}
                    </Typography>
                  </div>
                  <div className="list-data">
                    {" "}
                    <Typography variant={"label"} showBold color={tokens.Text.General.PrimaryBody}>
                      Due Date{" "}
                    </Typography>
                    <Typography variant={"body2"} color={getDateColor(el?.dueDate, el?.status)}>
                      {getUIFormatDate(el.dueDate)}
                    </Typography>
                  </div>
                  <div className="list-data">
                    <Typography variant={"body2"} color={getTableColor(el?.status)}>
                      {el?.status}
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
                      {" "}
                      <LinearProgress
                        sx={{ width: "64px", height: "6px" }}
                        variant="determinate"
                        value={(!isNaN(progressVal) ? progressVal : 0) * 100}
                      />
                      <Typography component={"span"}>
                        {" "}
                        {!isNaN(progressVal) ? `${Math.round(progressVal * 100)}%` : `0%`}
                      </Typography>
                    </Box>
                  </div>
                </div>
                <div className="btn-desktop">
                  {" "}
                  <Button
                    size="Small"
                    variant="primary"
                    label="Join Plan"
                    startIcon={<JoinUser />}
                    onClick={() => joinPlan(el)}
                  />
                </div>

                <div className="btn-mobile">
                  <Button iconButton icon={JoineUserMobile} onClick={() => joinPlan(el)}></Button>
                </div>
              </div>
            </div>
            {data?.length > 2 && arrowDown && index === 1 && (
              <div onClick={handleCollapse} className="cursor-pointer arrow-button-down">
                {<ArrowDown />}
              </div>
            )}
          </div>
          {data?.length > 2 && index === data?.length - 1 && (
            <div onClick={handleCollapse} className="cursor-pointer arrow-button-up-box">
              <div className="arrow-button-up"> {<ArrowUp />}</div>
            </div>
          )}
        </div>
      );
    });
  };
  const getSubTitle = () => {
    return (
      <Typography variant={"label"} color={tokens.Text.General.PrimaryBody}>
        You can <u>Join an Active Plan</u> or
        <u> Start New Plan</u>.
      </Typography>
    );
  };
  return (
    <div className="implemented-plan-dialog">
      <DialogFormation
        title={translate("library.addToMyPlan")}
        subTitle={getSubTitle()}
        openDialog={openDialog}
        handleClose={handleClose}
        actionConfig={
          <div className="action-config-container modal-config-wrapper-with-back vertical-center">
            <div className="action-config-text">
              <Typography component={"div"} variant={"body1"} showBold color={tokens.Text.General.PrimaryBody}>
                Or Start a New Plan
              </Typography>
              <Typography component={"div"} variant={"body2"} color={tokens.Text.General.PrimaryBody}>
                If you do not have an active plan, start a new plan. Share with your team to assign actions and due
                dates.
              </Typography>
            </div>
            <div className="action-config-button">
              <Button
                variant="primary"
                label="Start New Plan"
                startIcon={<NewPlan />}
                onClick={() => {
                  handleClose();
                  startNewPlan();
                }}
              />
            </div>
          </div>
        }
      >
        <div className="add-to-myplan-component">
          <div className="add-to-myplan-container-text">
            {" "}
            <Typography variant={"body1"} showBold color={tokens.Text.General.PrimaryBody}>
              Join an active plan(s).
            </Typography>
            <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody}>
              These plans are active and in progress. Join plan(s) to help contribute to your team's efforts.
            </Typography>
          </div>
          <div className="add-to-myplan-container-list">{getPlanListUi()}</div>
        </div>
      </DialogFormation>
    </div>
  );
};
export default AddToMyPlans;
